<template>
  <div class="login">
    <div class="login-left">
      <div class="content">
        <img src="../../assets/img/logo.svg" class="logo" />
        <h6>Sign up and start earning for FREE</h6>
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >
          <a-form-item>
            <a-input
              size="large"
              v-decorator="[
                'email',
                {
                  rules: [
                    { required: true, message: 'Please input your email!' }
                  ]
                }
              ]"
              placeholder="email"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              size="large"
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your Password!' }
                  ]
                }
              ]"
              type="password"
              placeholder="Password"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <reCaptcha
            :sitekey="recaptchaKey"
            @getValidateCode="getValidateCode"
          ></reCaptcha>
          <a-form-item>
            <a-button
              style="width: 100%"
              type="primary"
              html-type="submit"
              class="login-form-button"
              :loading="iconLoading"
              >sign up</a-button
            >
          </a-form-item>
        </a-form>
        <p class="register-msg">
          By clicking Sign up you agree to jetprintapp’s
          <span>Terms of Service,</span>
          <span>Privacy Policy</span>
          and
          <span>Intellectual Property Policy</span>
        </p>
        <p class="new">
          Already have an account?
          <a href="login">Sign in</a>
        </p>
      </div>
    </div>
    <div class="login-right"></div>
  </div>
</template>
<script>
import reCaptcha from "@/components/ReCaptcha";
import { Register } from "../../api/user";
export default {
  components: {
    reCaptcha
  },
  data() {
    return {
      iconLoading: false,
      recaptchaKey: process.env.VUE_APP_RECAPTCHAkEY, //recaptcha的key
      isRecaptcha: "" //验证是否通过
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
    console.log(this.form);
  },
  methods: {
    //获取recaptcha的token
    getValidateCode(value) {
      console.log("验证..." + value);
      this.isRecaptcha = value;
    },
    async handleSubmit(e) {
      this.iconLoading = true;
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (this.isRecaptcha == "") {
          this.$message.error("Please verify reCaptcha");
          return;
        }
        if (!err) {
          let { code, msg } = await Register({
            recaptchaToken: this.isRecaptcha,
            email: values.email,
            password: values.password
          });
          if (code == 200) {
            this.iconLoading = false;
            this.$router.push({ path: "/login", query: { isAlert: true } });
          } else {
            this.iconLoading = false;
            window.grecaptcha.reset();
            this.$message.error(msg);
          }
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/user.css";
</style>
